import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import ProfileListItem from "@/components/ProfileListItem.vue";
import { SearchItem } from "@/types";
import { computed, ref, watch } from "vue";

interface Props {
  members: SearchItem[];
  isSelectEnabled: boolean;
  isBriefcaseView: boolean;
  showFilters?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileList',
  props: {
    members: null,
    isSelectEnabled: { type: Boolean },
    isBriefcaseView: { type: Boolean },
    showFilters: { type: Boolean }
  },
  emits: ["clear-filter"],
  setup(__props: any, { emit }) {

const props = __props as {
  members: SearchItem[];
  isSelectEnabled: boolean;
  isBriefcaseView: boolean;
  showFilters?: boolean;
};




const showFilters = computed(() => props.showFilters ?? false);
const members = computed(() => props.members);

const search = ref("");

const partyFilter = ref("Any");
watch(partyFilter, (v) => {
  if (v === null) partyFilter.value = "Any";
});
const partiesInMembers = computed(() => {
  const parties = new Set<string>();
  members.value.forEach((member) => {
    if (member.politicalParty) parties.add(member.politicalParty);
  });
  return Array.from(parties);
});

const filteredMembers = computed(() => {
  let result = [];
  if (partyFilter.value === "Any") result = Array.from(members.value);
  else {
    for (const member of members.value) {
      if (member.politicalParty === partyFilter.value) {
        result.push(member);
      }
    }
  }
  if (!search.value) return result;
  return result.filter((m) => {
    const name = m.preferredNameDisplay.toLowerCase();
    const position = m.positionSummary.toLowerCase();
    const s = search.value.toLowerCase();
    return name.includes(s) || position.includes(s);
  });
});

const clearFilters = () => {
  search.value = "";
  partyFilter.value = "Any";
  emit("clear-filter");
};

return { __sfc: true,emit, props, showFilters, members, search, partyFilter, partiesInMembers, filteredMembers, clearFilters, NjBtn, ProfileListItem }
}

})